// extracted by mini-css-extract-plugin
export var alert = "newsletter-module--alert--a3c2b";
export var background = "newsletter-module--background--89660";
export var content = "newsletter-module--content--7e193";
export var description = "newsletter-module--description--6d5f0";
export var field = "newsletter-module--field--cd3ac";
export var fields = "newsletter-module--fields--f766c";
export var form = "newsletter-module--form--2cf3f";
export var guarantee = "newsletter-module--guarantee--b2f51";
export var header = "newsletter-module--header--6cec1";
export var heading = "newsletter-module--heading--9523f";
export var input = "newsletter-module--input--b6aa1";
export var newsletter = "newsletter-module--newsletter--c0a05";
export var newsletterBounce = "newsletter-module--newsletterBounce--5dadb";
export var poweredBy = "newsletter-module--poweredBy--fbc32";
export var poweredByContainer = "newsletter-module--poweredByContainer--f5eaf";
export var spinner = "newsletter-module--spinner--16b79";
export var subheader = "newsletter-module--subheader--264d7";
export var submit = "newsletter-module--submit--7f313";
export var submitLabel = "newsletter-module--submitLabel--121f8";
export var visuallyHidden = "newsletter-module--visuallyHidden--be9a6";